module.exports = __webpack_public_path__ + "static/media/image-upload.8f94c898.png";